import * as THREE from "https://esm.sh/three@0.169.0";
import { OrbitControls } from "https://esm.sh/three@0.169.0/examples/jsm/controls/OrbitControls.js";
import { GLTFLoader } from "https://esm.sh/three@0.169.0/examples/jsm/loaders/GLTFLoader.js";
import { EffectComposer } from "https://esm.sh/three@0.169.0/examples/jsm/postprocessing/EffectComposer.js";
import { RenderPass } from "https://esm.sh/three@0.169.0/examples/jsm/postprocessing/RenderPass.js";
import { SMAAPass } from "https://esm.sh/three@0.169.0/examples/jsm/postprocessing/SMAAPass.js";
// import fabric1 from './assets/fabrics/color2.png';
// import uv1 from './assets/fabrics/uv2.png';
// import fabric2 from './assets/fabrics/color.jpeg';
// import uv2 from './assets/fabrics/uv.png';
// import fabric3 from './assets/fabrics/color3.jpg';
// import uv3 from './assets/fabrics/uv.png';
// import buttonFabric3 from './assets/fabrics/C221-2.png';
// import buttonFabric2 from './assets/fabrics/MH1_Black-with-small-stain.png';
// import buttonFabric1 from './assets/fabrics/MH3_Dark-Brown_.png';

// ----- Global Variables -----
let scene, camera, renderer, controls, suitGroup, composer, renderPass;
let aLight = [], dirLight2, dirLight3, backLight, backLight2;
let cameraFollowLight; // Add this new variable
const loadedMeshes = {};

// Remove GUI variables and keep only the light offset
let lightOffset = {
  x: -20,
  y: 16.8,
  z: 10
};
const bodyElement = document.querySelector("body");
const dataPageValue = bodyElement.getAttribute("data-page");

// Default fabric color texture used when a fabric has no color image
// or when loading that image fails. Ideally provided via data-attribute.
const DEFAULT_FABRIC_TEXTURE_URL ="https://grand-le-mar-media-2.s3.ap-south-1.amazonaws.com/default/Poly_Wool_Fabric_Base_Map.jpg";

// Fallback fabric object when fetched/selected fabric is null.
// Ensures we still render using DEFAULT_FABRIC_TEXTURE_URL.
const DEFAULT_FABRIC_FALLBACK = {
    repeatable_color_image_url: null,
    repeatable_normal_image_url: null,
    color_r: 128,
    color_g: 128,
    color_b: 128,
    tiling_info: { color_tiling_x: 1, color_tiling_y: 1 },
};

// Add buttonhole lapel style to global variables
let currentButtoning, currentLapelStyle, currentShoulder, currentMartingaleBelt, currentInvertedBoxPleat, currentFront, currentChestPocket, currentSidePocket, currentSleeveDesign, currentLinings = 'full', currentVent = 'single', currentButtonholeLapelPosition = 'left', currentButtonholeLapel, currentLiningsColor = '#FFFFFF', sCurruntFabric, currentButtonfab = 'Horn_Black_(MH1)';
let allfabrics, defaultfabriccode = "";
// ----- Configuration Data -----
const CONFIG = {
  defaults: {
    buttoning: 'double_breasted_6',
    lapelStyle: 'notchpeak',
    shoulder: 'Unconstructed',
    martingaleBelt: true,
    invertedBoxPleat: true,
    chestPocket: "boat",
    sidePocket: "postbox",
    sleeveDesign: "cuffed",
    linings: true,
    vent: "single",
    buttonholeLapelPosition: "left",
    buttonholeLapel: "traditional", // Add this line
    fabric: "fabric1",
    buttonFabric: currentButtonfab, // Add button fabric default
    liningFabric: currentLiningsColor  // Add lining fabric default
  },
  // Define which lapel styles are available for each buttoning type
  lapelConstraints: {
    single_breasted_2: ['notch', 'peak'],
    double_breasted_6: ['notchpeak', 'peak']
  },

  assets: {
    buttoning: {
      single_breasted_2: '2_Buttons',
      double_breasted_6: '6_buttons',
    },
    lapelStyle: {
      notch: 'notch',
      peak: 'peak',
      notchpeak: 'notchpeak'
    },
    shoulder: {
      Structured: 'Structured',
      Unstructured: 'Unstructured',
      Lightly_Padded: 'Lightly_Padded'
    },

  },
//   // Add fabric assets mapping
//   fabrics: {
//     fabric1: {
//       color: fabric1,
//       normal: uv1,
//       name: 'Charcoal Grey'
//     },
//     fabric2: {
//       color: fabric2,
//       normal: uv2,
//       name: 'Light Beige'
//     },
//     fabric3: {
//       color: fabric3,
//       normal: uv3,
//       name: 'Linen'
//     }
//   },

//   // Add button fabric assets mapping
//   buttonFabrics: {
//     'button-fabric1': {
//       color: buttonFabric1, // MH3_Dark-Brown_.png
//       normal: '',
//       name: 'Dark Brown'
//     },
//     'button-fabric2': {
//       color: buttonFabric2, // MH1_Black-with-small-stain.png
//       normal: '',
//       name: 'Black'
//     },
//     'button-fabric3': {
//       color: buttonFabric3, // C221-2.png
//       normal: '',
//       name: 'Navy'
//     }
//   },

//   // Add lining fabric assets mapping
//   liningFabrics: {
//     'lining-fabric1': {
//       color: fabric1,
//       normal: uv1,
//       name: 'Charcoal Grey'
//     },
//     'lining-fabric2': {
//       color: fabric2,
//       normal: uv2,
//       name: 'Light Beige'
//     }
//   },

  // Add buttonhole lapel assets mapping
  buttonholeLapel: {
    traditional: 'traditional',
    'handmade-milanese': 'handmade_milanese'
  }
};

// Add new global variables for the flow control
let selectedMainFabric = null;
let currentScreen = 'fabric-selection'; // 'fabric-selection' or 'config'
fetchFabrics()

// ----- Three.js Initialization -----
function initThree() {
  scene = new THREE.Scene();
  scene.background = new THREE.Color(0xf0f0f0);

  // Get the viewer div dimensions
  const viewerDiv = document.getElementById("CanvasFrame");
  const viewerWidth = viewerDiv.clientWidth;
  const viewerHeight = viewerDiv.clientHeight;

  camera = new THREE.OrthographicCamera(
    viewerWidth / -720,
    viewerWidth / 720,
    viewerHeight / 720,
    viewerHeight / -720,
    1,
    1000
  );
  camera.position.set(0, 0, 12);
  camera.updateProjectionMatrix();
  camera.lookAt(0, 0, 0);

  // Update the renderer configuration
  renderer = new THREE.WebGLRenderer({
    alpha: true,
    antialias: true,
    preserveDrawingBuffer: true,
    powerPreference: "high-performance",
  });

  // Enable MSAA
  renderer.antialias = true;
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

  renderer.shadowMap.enabled = true;
  renderer.gammaInput = true;
  renderer.gammaOutput = true;

  renderer.setSize(viewerWidth, viewerHeight);

  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;

  composer = new EffectComposer(renderer);

  const smaaPass = new SMAAPass(
    renderer.getSize(new THREE.Vector2()).x * renderer.getPixelRatio(),
    renderer.getSize(new THREE.Vector2()).y * renderer.getPixelRatio()
  );
  composer.addPass(smaaPass);
  renderPass = new RenderPass(scene, camera);
  composer.addPass(renderPass);

  document.getElementById("CanvasFrame").appendChild(renderer.domElement);

  // Lighting
  const ambientLight = new THREE.AmbientLight(0xffffff, 0.4);
  scene.add(ambientLight);

  backLight = new THREE.DirectionalLight(0xffffff, 1);
  scene.add(backLight);
  backLight.position.set(10, 0, 10);

  // Create directional light that will follow camera with offset
  cameraFollowLight = new THREE.DirectionalLight(0xffffff, 3.9);
  cameraFollowLight.castShadow = true;
  cameraFollowLight.shadow.mapSize.width = 4096;  // Increased from 2048
  cameraFollowLight.shadow.mapSize.height = 4096; // Increased from 2048
  cameraFollowLight.shadow.camera.near = 0.5;
  cameraFollowLight.shadow.camera.far = 50;
  cameraFollowLight.shadow.camera.left = -10;
  cameraFollowLight.shadow.camera.right = 10;
  cameraFollowLight.shadow.camera.top = 10;
  cameraFollowLight.shadow.camera.bottom = -10;
  scene.add(cameraFollowLight);

  // Controls
  controls = new OrbitControls(camera, renderer.domElement);
  controls.enableDamping = true;
  controls.dampingFactor = 0.05;
  controls.enablePan = false;
  controls.minPolarAngle = Math.PI / 2;
  controls.maxPolarAngle = Math.PI / 2;
  controls.minZoom = 0.75;
  controls.maxZoom = 1.5;
  controls.enableZoom = false;
  controls.rotateSpeed = 0.5;
  controls.autoRotate = false;


  suitGroup = new THREE.Group();
  scene.add(suitGroup);

  // Remove GUI initialization
  // initGUI();
  loadJacketModel('https://grand-le-mar-media-2.s3.ap-south-1.amazonaws.com/overCoat.glb');
  animate();
}

// Remove the entire initGUI function

function animate() {
  // Update controls for smooth damping
  controls.update();

  if (cameraFollowLight) {
    const offset = new THREE.Vector3(lightOffset.x, lightOffset.y, lightOffset.z);
    offset.applyQuaternion(camera.quaternion);
    cameraFollowLight.position.copy(camera.position).add(offset);
    if (suitGroup) {
      cameraFollowLight.target.position.copy(suitGroup.position);
      cameraFollowLight.target.updateMatrixWorld();
    }
  }

  requestAnimationFrame(animate);
  composer.render();
}

function loadJacketModel(url) {
  const loader = new GLTFLoader();
  loader.load(url, async gltf => {
    const model = gltf.scene;
    suitGroup.clear();
    suitGroup.add(model);
    centerModel(model);

    console.log("model loaded::", model)
    // model.rotation.y = Math.PI;

    await storeTopLevelGroups(model);  // Add await here
    fetchFabrics();
    applyDefaultConfig();              // Now this runs after meshes are stored
  }, undefined, function (error) {
    console.error('An error occurred loading the model:', error);
  });
}

function centerModel(model) {
  const box = new THREE.Box3().setFromObject(model);
  const center = box.getCenter(new THREE.Vector3());
  const size = box.getSize(new THREE.Vector3());

  model.position.sub(center);
  const maxDim = Math.max(size.x, size.y, size.z);
  const scale = 2 / maxDim;
  model.scale.setScalar(scale);
  box.setFromObject(model);
  const newCenter = box.getCenter(new THREE.Vector3());
  model.position.sub(newCenter);
}

function setAllMeshesInvisible(object) {
  object.traverse((child) => {
    child.visible = false;
  });
}

async function storeTopLevelGroups(root) {
  return new Promise((resolve) => {
    root.children.forEach(child => {
      if (child.name) {
        loadedMeshes[child.name] = child; // group of options
        setAllMeshesInvisible(child);
      }
    });
    resolve();
  });
}

function updateVariant(groupName, visibleChildName, toggle = true, visibility = true) {
  const group = loadedMeshes[groupName]; // e.g., lapel, Buttons, shoulders
  if (!group) {
    console.warn(`Group '${groupName}' not found`);
    return;
  }

  // Check if the group is visible, if not make it visible
  if (!group.visible) {
    group.visible = true;
  }

  if (group.isMesh) {
    group.visible = visibility;
    return;
  }

  if (visibleChildName === "none") {
    group.children.forEach(child => {
      child.visible = false;
    });
  } else {
    group.children.forEach(child => {
      if (child.name === visibleChildName) {
        child.visible = visibility; // Use the visibility parameter here
        child.traverse(subChild => {
          subChild.visible = visibility; // Also apply visibility to sub-children
        });
      } else {
        if (toggle) {
          child.visible = false;
        } else {
          child.visible = true;
        }
      }
    });
  }
}

function applyDefaultConfig() {
  // scaleButtonsOnXAxis(1.09);
  updateLapelStyle(CONFIG.defaults.lapelStyle);
  updateButtoning(CONFIG.defaults.buttoning);
  updateShoulders(CONFIG.defaults.shoulder);
  updateFront();
  martingaleBelt(CONFIG.defaults.martingaleBelt);
  invertedBoxPleat(CONFIG.defaults.invertedBoxPleat);
  updateChestPocket(CONFIG.defaults.chestPocket);
  updateSidePocket(CONFIG.defaults.sidePocket);
  updateSleeveDesign(CONFIG.defaults.sleeveDesign);
  updateLinings(); // Remove parameter, let it determine dynamically
  updateVent(CONFIG.defaults.vent);
  updateButtonholeLapelPosition(CONFIG.defaults.buttonholeLapelPosition);
  updateButtonholeLapel(CONFIG.defaults.buttonholeLapel); // Add this line
  updateLiningFabric(CONFIG.defaults.liningFabric); // Add lining fabric update
  updateButtonFabric(CONFIG.defaults.buttonFabric); // Add button fabric update
  // updateFabric(CONFIG.defaults.fabric); // Add fabric update
}



///Start of update functions
function updateLapelStyle(styleKey) {
  const lapelMap = {
    notch: 'noatch',
    peak: 'Peak',
    DB_peak: 'DB_peak',
    notchpeak: 'notchpeak'
  };

  // Determine the appropriate lapel mapping based on buttoning type and selected style
  if (styleKey === 'peak' && (currentButtoning === 'double_breasted_6' || currentButtoning === '6_buttons')) {
    styleKey = 'DB_peak'; // Use DB_peak if double breasted and peak is selected
  }

  currentLapelStyle = styleKey;
  updateVariant('lapel', lapelMap[styleKey]);

  // Update the buttonhole lapel position when the lapel style changes
  updateButtonholeLapelPosition(currentButtonholeLapelPosition || CONFIG.defaults.buttonholeLapelPosition);
}

// Update the button mesh names to be consistent
function updateButtoning(styleKey, toggle = true, visibility = true) {
  const buttoningMap = {
    single_breasted_2: '2_Buttons',
    double_breasted_6: '6_buttons',
    belt_buttons: 'belt_button',
    one_strap: 'one_strap_button',
    pleat_buttons: 'pleat_buttons',
    sec_strap: 'sec_strap'
  };

  currentButtoning = styleKey;
  updateVariant('Buttons', buttoningMap[styleKey], toggle, visibility);
}

function updateFront() {
  const currentLapel = CONFIG.defaults.lapelStyle;
  let frontStyleKey;

  if (currentButtoning === 'single_breasted_2') {
    frontStyleKey = `2_Buttons_Front_${currentShoulder}`;
  } else if (currentButtoning === 'double_breasted_6') {
    frontStyleKey = `6_Buttons_Front_${currentShoulder}`;
  } else {
    console.warn(`Unsupported buttoning type for front: ${currentButtoning}`);
    return;
  }

  const frontMap = {
    '2_Buttons_Front_Structured': '2Button_Structured',
    '2_Buttons_Front_Unconstructed': '2Button_Unconstructed',
    '2_Buttons_Front_Lightly_Padded': '2Button_Lightly_padded',
    '6_Buttons_Front_Structured': '6Button_Structured',
    '6_Buttons_Front_Unconstructed': '6Button_Unconstructed',
    '6_Buttons_Front_Lightly_Padded': '6Button_Lightly_Padded',
  };
  updateVariant('Front', frontMap[frontStyleKey]);
}

function updateShoulders(styleKey) {
  const shoulderMap = {
    Structured: 'Structured',
    Unconstructed: 'Unconstructed',
    Lightly_Padded: 'Lightly_Padded',
  };

  currentShoulder = styleKey;

  const shoulderGroup = loadedMeshes['shoulders'];
  if (!shoulderGroup) {
    console.warn('Shoulder group not found');
    return;
  }

  // Make the shoulder group visible
  shoulderGroup.visible = true;

  // Find the Natural_Shoulder child
  const naturalShoulder = shoulderGroup.children.find(child => child.name === 'Natural_Shoulder');
  if (!naturalShoulder) {
    console.warn('Natural_Shoulder not found');
    return;
  }

  // Make Natural_Shoulder visible
  naturalShoulder.visible = true;
  const variantName = shoulderMap[styleKey] || 'Structured';

  // Hide all variants first, then show only the target one
  naturalShoulder.children.forEach(variant => {
    if (variant.name === variantName) {
      variant.visible = true;
      // Make all nested children of this variant visible
      variant.traverse((subChild) => {
        subChild.visible = true;
      });
    } else {
      variant.visible = false;
      // Make all nested children of other variants invisible
      variant.traverse((subChild) => {
        subChild.visible = false;
      });
    }
  });
}

// Fix the martingale belt function to use correct mesh names
function martingaleBelt(styleKey, visibility = true) {
  currentMartingaleBelt = styleKey;
  const ButtonsGroup = loadedMeshes['Buttons'];
  if (ButtonsGroup) {
    ButtonsGroup.traverse((child) => {
      if (child.name === "belt_button" || child.name === "belt_buttons") {
        child.visible = visibility;
        child.traverse((subChild) => {
          subChild.visible = visibility;
        });
      }
    });
  }

  updateVariant('Martingale_Belt', "none", true, visibility);
}

// Fix the inverted box pleat function to use correct mesh names
function invertedBoxPleat(styleKey, visibility = true) {

  function updatePleatButtons(visibility) {
    const pleatButtonsGroup = loadedMeshes['Buttons'];
    if (pleatButtonsGroup) {
      pleatButtonsGroup.traverse((child) => {
        if (child.name === "pleat_buttons") {
          child.visible = visibility;
          child.traverse((subChild) => {
            subChild.visible = visibility;
          });
        }
      });
    }
  }

  if (styleKey == "false" || styleKey == false || styleKey == "true" || styleKey == true) {
    currentInvertedBoxPleat = styleKey;
  }

  if (currentInvertedBoxPleat === "false" || currentInvertedBoxPleat === false || currentVent === "single") {
    updateVariant('Inverted_Box_Pleat', "none", true, false);
    updateVent(CONFIG.defaults.vent);
    if (currentVent != "single") {
      updatePleatButtons(false);
    }
    return;
  }

  const buttoningConfig = currentButtoning || CONFIG.defaults.buttoning;
  const shoulderConfig = currentShoulder || CONFIG.defaults.shoulder;

  // Map buttoning and shoulder configuration to the appropriate pleat variant
  const pleatVariantMap = {
    '6_Buttons_Structured': '6button_Structured_Inverted_box_pleat',
    '6_Buttons_Unconstructed': '6button_Unconstructed_Inverted_box_pleat',
    '6_Buttons_Lightly_Padded': '6buttonLightly_Padded_Inverted_box_pleat',
    '2_Buttons_Structured': 'Structured_Inverted_box_pleat_2Button',
    '2_Buttons_Unconstructed': 'Unconstructed_Inverted_box_pleat_2Button',
    '2_Buttons_Lightly_Padded': 'Lightly_Padded_Inverted_box_pleat_2Button'
  };

  // Create the key based on buttoning and shoulder
  let pleatKey;
  if (buttoningConfig === 'single_breasted_2') {
    pleatKey = `2_Buttons_${shoulderConfig}`;
  } else if (buttoningConfig === 'double_breasted_6') {
    pleatKey = `6_Buttons_${shoulderConfig}`;
  } else {
    console.warn(`Unsupported buttoning type for inverted box pleat: ${buttoningConfig}`);
    return;
  }

  const targetPleatVariant = pleatVariantMap[pleatKey];
  if (targetPleatVariant) {
    updatePleatButtons(true);
    updateVariant('Inverted_Box_Pleat', targetPleatVariant, true, visibility);
  } else {
    console.warn(`No pleat variant found for buttoning: ${buttoningConfig}, shoulder: ${shoulderConfig}`);
  }
}

function updateChestPocket(styleKey) {
  currentChestPocket = styleKey;
  const chestPocketMap = {
    'boat': 'boat',
    'none': 'none',
  };
  updateVariant('ChestPocket', chestPocketMap[styleKey]);
}

function updateSidePocket(styleKey) {
  const sidePocketMap = {
    'jetted': 'jetted_pocket',
    'flaps': 'Patch',
    'postbox': 'postbox_pocket',
    'slanted-welt': 'slanted',
  };
  currentSidePocket = styleKey;
  updateVariant('Sidepocket', sidePocketMap[styleKey]);
}

// Fix the sleeve design function to use correct mesh names
function updateSleeveDesign(styleKey) {
  const sleeveDesignMap = {
    'un-cuffed': 'un_cuffed',
    'cuffed': 'cuffed',
    'sleeve-strap': 'Sleeve_Strap',
    'sleeve-strap-with-buttons': 'Full_Sleeve_Strap_with_buttons'
  };

  // Handle sleeve-specific buttons separately without affecting main buttoning
  if (styleKey === 'sleeve-strap-with-buttons') {
    updateVariant('sleave_buttons', 'sec_strap', true);
  } else if (styleKey === 'sleeve-strap') {
    updateVariant('sleave_buttons', 'one_strap_button', true);
  } else if (styleKey === 'un-cuffed' || styleKey === 'cuffed') {
    updateVariant('sleave_buttons', 'none', true);
  }

  currentSleeveDesign = styleKey;
  updateVariant('Sleeve_design', sleeveDesignMap[styleKey]);
}

function updateLinings(currentlining, visibility = true) {
  // Get the buttoning configuration to determine lining type
  const buttoningConfig = currentButtoning || CONFIG.defaults.buttoning;

  // Determine lining type based on buttoning (this logic remains the same)
  let liningType;
  if (buttoningConfig === 'single_breasted_2') {
    liningType = 'full';
  } else if (buttoningConfig === 'double_breasted_6') {
    liningType = 'full';
  } else {
    console.warn(`Unsupported buttoning type for lining: ${buttoningConfig}`);
    return;
  }

  currentLinings = liningType;

  const liningMap = {
    full: 'full',
    half: 'full',
  };

  function updateSleeveLinings() {
    const sleeveLiningsGroup = loadedMeshes['lining'];
    if (sleeveLiningsGroup) {
      const targetVariant = sleeveLiningsGroup.children.find(variant => variant.name === "LiningSleeve");
      if (targetVariant) {
        targetVariant.visible = visibility;
      }
    }
  }

  // Update the main lining with the determined type and visibility
  updateVariant('lining', liningMap[liningType], true, visibility);
  updateSleeveLinings();
}

function updateVent(ventType = currentVent) {
  // Helper function to show/hide pleat buttons
  function updatePleatButtons(visibility) {
    const pleatButtonsGroup = loadedMeshes['Buttons'];
    if (pleatButtonsGroup) {
      pleatButtonsGroup.traverse((child) => {
        if (child.name === "pleat_buttons") {
          child.visible = visibility;
          child.traverse((subChild) => {
            subChild.visible = visibility;
          });
        }
      });
    }
  }

  const buttoningConfig = currentButtoning || CONFIG.defaults.buttoning;
  const shoulderConfig = currentShoulder || CONFIG.defaults.shoulder;
  const martingaleBeltValue = currentMartingaleBelt ?? CONFIG.defaults.martingaleBelt;
  const invertedBoxPleatValue = currentInvertedBoxPleat ?? CONFIG.defaults.invertedBoxPleat;
  const isMartingaleEnabled = martingaleBeltValue === true || martingaleBeltValue === "true";
  const isPleatEnabled = invertedBoxPleatValue === true || invertedBoxPleatValue === "true";

  // Reset all vent groups off
  updateVariant('vent', "none", true, false);
  updateVariant('vent_Single_with_Button', "none", true, false);
  updateVariant('no_vent', "none", true, false);
  updateVariant('pleat_with_single_vent', "none", true, false);

  if (ventType == "vent_Single_with_Button" && isPleatEnabled) {
    currentVent = "vent_Single_with_Button";
    invertedBoxPleat("true");
    updatePleatButtons(true);
    return;
  }

  // Determine selected vent from UI or default
  let selectedVentType = ventType || getConfigValue('vent') || CONFIG.defaults.vent;

  // Helper to resolve map keys
  const configKey = buttoningConfig === 'single_breasted_2'
    ? `2Button_${shoulderConfig}`
    : `6Button_${shoulderConfig}`;

  const baseSingleVentMap = {
    '6Button_Structured': '6Button_Vent_Structured',
    '6Button_Unconstructed': '6Button_vent_Unconstructed',
    '6Button_Lightly_Padded': '6Button_lightly_Padded',
    '2Button_Structured': '2button_vent_Structured',
    '2Button_Unconstructed': '2button_vent_unconstructured',
    '2Button_Lightly_Padded': '2button_vent_lightly_padded'
  };

  // When martingale is disabled, we always fall back to single vent (standard vent, no pleat)
  if (!isMartingaleEnabled) {
    selectedVentType = 'single';
    const targetVentVariant = baseSingleVentMap[configKey];
    if (targetVentVariant) {
      updateVariant('Inverted_Box_Pleat', "none", true, false);
      updateVariant('pleat_with_single_vent', "none", true, false);
      updateVariant('no_vent', "none", true, false);
      updateVariant('vent', targetVentVariant, true, true);
      updatePleatButtons(false);
      currentVent = "single";
    } else {
      console.warn(`No vent variant found for martingale-off config: ${configKey}`);
    }
    return;
  }

  if (selectedVentType === 'single') {
    if (isPleatEnabled) {
      const pleatVentMap = {
        '6Button_Structured': 'Structrured_pleat_Vent_6',
        '6Button_Unconstructed': 'Unconstructed_pleat_Vent_6',
        '6Button_Lightly_Padded': 'Lightly_Padded_pleat_Vent_6',
        '2Button_Structured': 'Structrured_pleat_Vent_2',
        '2Button_Unconstructed': 'Unconstructed_pleat_Vent_2',
        '2Button_Lightly_Padded': 'Lightly_Padded_pleat_Vent_2'
      };
      const targetPleatVariant = pleatVentMap[configKey];
      if (targetPleatVariant) {
        // Hide the existing inverted pleat meshes when replacing them with the single-vent variant
        updateVariant('Inverted_Box_Pleat', "none", true, false);
        updateVariant('pleat_with_single_vent', targetPleatVariant, true, true);
        updatePleatButtons(false);
        currentVent = "single";
      } else {
        console.warn(`No pleat_with_single_vent variant found for: ${configKey}`);
      }
    } else {
      const ventMap = {
        '6Button_Structured': '6Button_Vent_Structured',
        '6Button_Unconstructed': '6Button_vent_Unconstructed',
        '6Button_Lightly_Padded': '6Button_lightly_Padded',
        '2Button_Structured': '2button_vent_Structured',
        '2Button_Unconstructed': '2button_vent_unconstructured',
        '2Button_Lightly_Padded': '2button_vent_lightly_padded'
      };
      const targetVentVariant = ventMap[configKey];
      if (targetVentVariant) {
        updateVariant('vent', targetVentVariant, true, true);
        updatePleatButtons(false);
        currentVent = "single";
      } else {
        console.warn(`No vent variant found for: ${configKey}`);
      }
    }
    return;
  }

  if (selectedVentType === 'vent_Single_with_Button' && !isPleatEnabled) {
    const ventWithButtonMap = {
      '6Button_Structured': '6button_Structured_vent_Single',
      '6Button_Unconstructed': '6button_Unconstructed_vent_Single',
      '6Button_Lightly_Padded': '6buttonLightly_Padded_vent_Single',
      '2Button_Structured': 'Structured_vent_Single',
      '2Button_Unconstructed': "Unconstructed_vent_Single",
      '2Button_Lightly_Padded': 'Lightly_Padded_vent_Single'
    };
    const targetVentWithButton = ventWithButtonMap[configKey];
    if (targetVentWithButton) {
      updateVariant('vent_Single_with_Button', targetVentWithButton, true, true);
      updatePleatButtons(true);
      currentVent = "vent_Single_with_Button";
    } else {
      console.warn(`No vent_Single_with_Button variant found for: ${configKey}`);
    }
  }
}

function updateButtonholeLapelPosition(styleKey = currentButtonholeLapelPosition) {
  currentButtonholeLapelPosition = styleKey;

  // Get the current lapel style to determine which buttons to show/hide
  const currentLapel = currentLapelStyle || CONFIG.defaults.lapelStyle;
  const currentButtonholeStyle = currentButtonholeLapel || CONFIG.defaults.buttonholeLapel;

  // Map lapel styles to their corresponding group names in the hierarchy
  const lapelGroupMap = {
    notch: 'noatch',
    peak: 'Peak',
    notchpeak: 'notchpeak',
    DB_peak: 'DB_peak',
  };

  const currentLapelGroup = lapelGroupMap[currentLapel];

  if (!currentLapelGroup) {
    console.warn(`No lapel group found for style: ${currentLapel}`);
    return;
  }

  // Get the lapel group from loaded meshes
  const lapelGroup = loadedMeshes['lapel'];
  if (!lapelGroup) {
    console.warn('Lapel group not found');
    return;
  }

  // Find the current lapel style group (noatch, Peak, notchpeak, or DB_peak)
  const currentLapelStyleGroup = lapelGroup.children.find(child => child.name === currentLapelGroup);
  if (!currentLapelStyleGroup) {
    console.warn(`Lapel style group '${currentLapelGroup}' not found`);
    return;
  }

  // Define button names based on the specific hierarchy structure for each lapel type and buttonhole style
  const buttonNames = {
    notch: {
      traditional: {
        left: 'notch_lapel_left_traditional',
        right: 'notch_lapel_right_traditional'
      },
      'handmade-milanese': {
        left: 'notch_left_Handmade_milanese',
        right: 'notch_right_Handmade_milanese'
      }
    },
    peak: {
      traditional: {
        left: 'peak_left_traditional_button',
        right: 'peak_right_traditional_button'
      },
      'handmade-milanese': {
        left: 'peak_left_Handmade_milanese',
        right: 'peak_right_Handmade_milanese'
      }
    },
    DB_peak: {
      traditional: {
        left: 'peak_lapel_left_traditional',
        right: 'peak_lapel_right_traditional'
      },
      'handmade-milanese': {
        left: 'peak_left_Handmade_milanese001',
        right: 'peak_right_Handmade_milanese001'
      }
    },
    notchpeak: {
      traditional: {
        left: 'notchpeak_lapel_left_traditional',
        right: 'notchpeak_lapel_right_traditional'
      },
      'handmade-milanese': {
        left: 'notchpeak_left_Handmade_milanese',
        right: 'notchpeak_right_Handmade_milanese'
      }
    }
  };

  // Get the button names for the current lapel style and buttonhole style
  const currentButtonNames = buttonNames[currentLapel]?.[currentButtonholeStyle];
  if (!currentButtonNames) {
    console.warn(`No button names defined for lapel style: ${currentLapel}, buttonhole style: ${currentButtonholeStyle}`);
    return;
  }

  // FIRST: Hide ALL buttonhole variants completely (both traditional and handmade-milanese)
  // This ensures no other variants are visible
  currentLapelStyleGroup.children.forEach(child => {
    // Hide any child that contains buttonhole-related names
    if (child.name.includes('traditional') ||
      child.name.includes('Handmade_milanese') ||
      child.name.includes('button') ||
      child.name.includes('lapel_left') ||
      child.name.includes('lapel_right') ||
      child.name.includes('_left_') ||
      child.name.includes('_right_')) {
      child.visible = false;
      child.traverse(subChild => {
        subChild.visible = false;
      });
    }
  });

  // SECOND: Show ONLY the selected buttonhole variants based on position
  switch (styleKey) {
    case 'left':
      // Show only left button of the current buttonhole style
      const leftButton = currentLapelStyleGroup.children.find(child => child.name === currentButtonNames.left);
      if (leftButton) {
        leftButton.visible = true;
        leftButton.traverse(subChild => subChild.visible = true);
      }
      break;

    case 'right':
      // Show only right button of the current buttonhole style
      const rightButton = currentLapelStyleGroup.children.find(child => child.name === currentButtonNames.right);
      if (rightButton) {
        rightButton.visible = true;
        rightButton.traverse(subChild => subChild.visible = true);
      }
      break;

    case 'both':
      // Show both buttons of the current buttonhole style
      [currentButtonNames.left, currentButtonNames.right].forEach(buttonName => {
        const button = currentLapelStyleGroup.children.find(child => child.name === buttonName);
        if (button) {
          button.visible = true;
          button.traverse(subChild => subChild.visible = true);
        }
      });
      break;

    case 'none':
      // Keep all buttonhole variants hidden
      break;

    default:
      console.warn(`Unknown buttonhole position: ${styleKey}`);
      break;
  }
}

// Update the buttonhole lapel function to match actual mesh names
function updateButtonholeLapel(styleKey) {
  currentButtonholeLapel = styleKey;

  // Get the current lapel style to determine which buttonhole group to update
  const currentLapel = currentLapelStyle || CONFIG.defaults.lapelStyle;

  // Map lapel styles to their corresponding group names in the hierarchy
  const lapelGroupMap = {
    notch: 'noatch',
    peak: 'Peak',
    notchpeak: 'notchpeak'
  };

  const currentLapelGroup = lapelGroupMap[currentLapel];

  if (!currentLapelGroup) {
    console.warn(`No lapel group found for style: ${currentLapel}`);
    return;
  }

  // Get the lapel group from loaded meshes
  const lapelGroup = loadedMeshes['lapel'];
  if (!lapelGroup) {
    console.warn('Lapel group not found');
    return;
  }

  // Find the current lapel style group (notch, Peak, or notchpeak)
  const currentLapelStyleGroup = lapelGroup.children.find(child => child.name === currentLapelGroup);
  if (!currentLapelStyleGroup) {
    console.warn(`Lapel style group '${currentLapelGroup}' not found`);
    return;
  }

  // Define buttonhole style variants for each lapel type based on actual mesh names
  const buttonholeStyleMap = {
    notch: {
      traditional: ['notch_lapel_left_traditional', 'notch_lapel_right_traditional'],
      'handmade-milanese': ['notch_left_Handmade_milanese', 'notch_right_Handmade_milanese']
    },
    peak: {
      traditional: ['peak_left_traditional_button', 'peak_right_traditional_button'],
      'handmade-milanese': ['peak_left_Handmade_milanese', 'peak_right_Handmade_milanese']
    },
    notchpeak: {
      traditional: ['notchpeak_lapel_left_traditional', 'notchpeak_lapel_right_traditional'],
      'handmade-milanese': ['notchpeak_left_Handmade_milanese', 'notchpeak_right_Handmade_milanese']
    }
  };

  // Get the buttonhole style variants for the current lapel style
  const currentButtonholeStyles = buttonholeStyleMap[currentLapel];
  if (!currentButtonholeStyles) {
    console.warn(`No buttonhole styles defined for lapel style: ${currentLapel}`);
    return;
  }

  // Hide ALL buttonhole style variants first (both traditional and handmade-milanese)
  currentLapelStyleGroup.children.forEach(child => {
    if (child.name.includes('traditional') || child.name.includes('Handmade_milanese')) {
      child.visible = false;
      child.traverse(subChild => subChild.visible = false);
    }
  });

  // Show only the selected buttonhole style variant
  const targetButtonholeVariants = currentButtonholeStyles[styleKey];
  if (targetButtonholeVariants) {
    targetButtonholeVariants.forEach(variantName => {
      const buttonholeMesh = currentLapelStyleGroup.children.find(child => child.name === variantName);
      if (buttonholeMesh) {
        buttonholeMesh.visible = true;
        buttonholeMesh.traverse(subChild => subChild.visible = true);
      } else {
        console.warn(`Buttonhole variant '${variantName}' not found`);
      }
    });
  }

  // After updating buttonhole style, also update the position to ensure proper visibility
  const currentButtonholePosition = currentButtonholeLapelPosition || CONFIG.defaults.buttonholeLapelPosition;
  updateButtonholeLapelPosition(currentButtonholePosition);
}

///End of update functions

/**
 * Get the current active configuration from the UI
 * @returns {Object} Current configuration object
 */
function getCurrentConfig() {
  const config = {};

  // Map of select IDs to their corresponding config keys
  const selectMapping = {
    'buttoning-select': 'buttoning',
    'lapel-style-select': 'lapelStyle',
    'shoulder-select': 'shoulder',
    'martingale-belt-select': 'martingaleBelt',
    'inverted-box-pleat-select': 'invertedBoxPleat',
    'vent-select': 'vent',
    'chest-pocket-select': 'chestPocket',
    'side-pocket-select': 'sidePocket',
    'sleeve-design-select': 'sleeveDesign',
    'lining-select': 'linings',
    'buttonhole-lapel-position-select': 'buttonholeLapelPosition',
    'buttonhole-lapel-select': 'buttonholeLapel' // Add this line
  };

  // Get values from all select elements
  Object.entries(selectMapping).forEach(([selectId, configKey]) => {
    const selectElement = document.getElementById(selectId);
    if (selectElement) {
      let value = selectElement.value;

      // Convert string boolean values to actual booleans
      if (value === 'true') {
        value = true;
      } else if (value === 'false') {
        value = false;
      }

      config[configKey] = value;
    }
  });

  // Add fabric configurations
  config.fabric = CONFIG.defaults.fabric;
  config.buttonFabric = CONFIG.defaults.buttonFabric;
  config.liningFabric = CONFIG.defaults.liningFabric;

  // Also include the current global variables for completeness
  config.currentButtoning = currentButtoning;
  config.currentLapelStyle = currentLapelStyle;
  config.currentShoulder = currentShoulder;
  config.currentMartingaleBelt = currentMartingaleBelt;
  config.currentInvertedBoxPleat = currentInvertedBoxPleat;
  config.currentFront = currentFront;
  config.currentChestPocket = currentChestPocket;
  config.currentSidePocket = currentSidePocket;
  config.currentSleeveDesign = currentSleeveDesign;
  config.currentLinings = currentLinings;
  config.currentVent = currentVent;
  config.currentButtonholeLapelPosition = currentButtonholeLapelPosition;
  config.currentButtonholeLapel = currentButtonholeLapel; // Add this line

  return config;
}

/**
 * Get a specific configuration value
 * @param {string} configKey - The configuration key to retrieve
 * @returns {*} The configuration value
 */
function getConfigValue(configType) {
  const allCards = document.querySelectorAll(".cm-modifier-card-container");
  let resultTitleTextWithoutSpaces = null;
  for (const card of allCards) {
    const filterLabel = card.querySelector(".cm-modifier-col-title");
    const resultTitleDiv = card.querySelector(".cm-modifier-result-title");

    if (filterLabel && resultTitleDiv) {
      const filterLabelValue = filterLabel.textContent.trim();
      if (filterLabelValue === configType) {
        // Clean the result text for comparison/use
        const rawText = resultTitleDiv.textContent.trim();
        resultTitleTextWithoutSpaces = rawText.replace(/[^a-zA-Z0-9]/g, "_");

        // The demo.js file performs a lot of specific text transformation/cleanup.
        // We'll return the value here and handle the specific mapping in the main function.
        return resultTitleTextWithoutSpaces;
      }
    }
  }
  return null;
}

async function fetchFabrics() {
    const response = await axios.get(
        "https://grand-le-mar.lc.webdevprojects.cloud/api/v1/fetch/fabrics"
    );
    allfabrics = response.data.data;
    const fid = response.data.data?.filter(
        (fabric) => fabric.id === defaultfabriccode
    );
    sCurruntFabric = fid[0];
    updateFabric(sCurruntFabric ?? DEFAULT_FABRIC_FALLBACK);
}


const fabricLists = document.querySelectorAll(".cm-card-list fabric-list");

if (fabricLists.length > 0) {
    const firstFabricList = fabricLists[0];
    const contentWrapper = firstFabricList.querySelector(
        ".cm-card-content-wrapper"
    );

    if (contentWrapper) {
        const fabricId = contentWrapper.getAttribute("data-fabricid");
        defaultfabriccode = fabricId;
        //console.log("First fabric ID:", fabricId);
    } else {
        //console.log("No content wrapper found within the first fabric-list tag.");
    }
} else {
    //console.log("No fabric-list tags found.");
}

fabricLists.forEach((fabricList) => {
    fabricList.addEventListener("click", function () {
        //console.log("clicked on fabric");
        const contentWrapper = this.querySelector(".cm-card-content-wrapper");
        if (contentWrapper) {
            const fabricId = contentWrapper.getAttribute("data-fabricid");
            const fid = allfabrics?.filter((fabric) => fabric.id === fabricId);

            sCurruntFabric = fid[0];
            updateFabric(fid?.[0] ?? DEFAULT_FABRIC_FALLBACK);
        } else {
            console.log(
                "No content wrapper found within the clicked fabric-list tag."
            );
        }
    });
});

/**
 * Unified function to apply textures to specific mesh groups
 * @param {THREE.Texture} colorTexture - The fabric color texture to apply
 * @param {THREE.Texture} normalTexture - The fabric normal texture to apply
 * @param {Array} targetGroups - Array of group names to apply textures to
 * @param {Object} materialOptions - Additional material properties
 * @param {Array} excludeGroups - Array of group names to exclude
 */
function applyTexturesToGroups(colorTexture, normalTexture, targetGroups, materialOptions = {}, excludeGroups = []) {
  if (!suitGroup || !targetGroups || targetGroups.length === 0) return;

  // Configure texture settings
  const configureTexture = (texture) => {
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;
    texture.encoding = THREE.sRGBEncoding;

    const maxAnisotropy = renderer.capabilities.getMaxAnisotropy();
    texture.anisotropy = maxAnisotropy

    texture.generateMipmaps = true;
    texture.minFilter = THREE.LinearMipmapLinearFilter;
    texture.magFilter = THREE.LinearFilter;

    const repeatX = materialOptions.repeat?.[0] || 10;
    const repeatY = materialOptions.repeat?.[1] || 10;
    texture.repeat.set(repeatX, repeatY);
  };

  // Configure both textures
  configureTexture(colorTexture);
  if (normalTexture) {
    configureTexture(normalTexture);
  }

  // Function to check if a mesh belongs to target groups
  function isTargetGroup(mesh) {
    if (!mesh.name) return false;

    // Check if mesh is in exclude groups
    if (excludeGroups.some(exclude => mesh.name.toLowerCase().includes(exclude.toLowerCase()))) {
      return false;
    }

    // Check if mesh is in target groups
    return targetGroups.some(target => mesh.name.toLowerCase().includes(target.toLowerCase()));
  }

  // Function to check if a mesh belongs to target groups (including parent hierarchy)
  function isInTargetGroup(mesh) {
    if (isTargetGroup(mesh)) return true;

    let parent = mesh.parent;
    while (parent) {
      if (isTargetGroup(parent)) return true;
      parent = parent.parent;
    }
    return false;
  }

  // Function to apply textures to a mesh
  function applyTexturesToMesh(mesh) {
    if (mesh.isMesh && mesh.material && isInTargetGroup(mesh)) {
      mesh.material.map = colorTexture;
      if (normalTexture) {
        mesh.material.normalMap = normalTexture;
        mesh.material.normalMap.needsUpdate = true;
      }

      if (mesh.material.name === "Line_Mat" || mesh.material.name === "Thread_Mat") {
        mesh.material.color.setScalar(0.7);
      }

      mesh.material.polygonOffset = true;
      mesh.material.polygonOffsetFactor = 1;
      mesh.material.polygonOffsetUnits = 1;

      mesh.material.depthWrite = true;
      mesh.material.depthTest = true;
      mesh.material.roughness = 1;
      mesh.material.metalness = 0.3;

      mesh.material.needsUpdate = true;
    }
  }

  // Traverse and apply textures
  suitGroup.traverse((child) => {
    applyTexturesToMesh(child);
  });
}

/**
 * Unified function to apply textures to specific mesh groups with material name constraint
 * @param {THREE.Texture} colorTexture - The fabric color texture to apply
 * @param {THREE.Texture} normalTexture - The fabric normal texture to apply
 * @param {Array} targetGroups - Array of group names to apply textures to
 * @param {Object} materialOptions - Additional material properties
 * @param {Array} excludeGroups - Array of group names to exclude
 * @param {string} excludeMaterialName - Material name to exclude from texture application
 */
function applyTexturesToGroupsWithMaterialConstraint(colorTexture, normalTexture, targetGroups, materialOptions = {}, excludeGroups = [], excludeMaterialName = '', type) {
  if (!suitGroup || !targetGroups || targetGroups.length === 0) return;
  // Configure texture settings
  const configureTexture = (texture) => {
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;
    texture.encoding = THREE.sRGBEncoding;

    const maxAnisotropy = renderer.capabilities.getMaxAnisotropy();
    texture.anisotropy = maxAnisotropy

    texture.generateMipmaps = true;
    texture.minFilter = THREE.LinearMipmapLinearFilter;
    texture.magFilter = THREE.LinearFilter;

    const repeatX = materialOptions.repeat?.[0] || 10;
    const repeatY = materialOptions.repeat?.[1] || 10;
    texture.repeat.set(repeatX, repeatY);
  };

  // Configure both textures
  configureTexture(colorTexture);
  if (normalTexture) {
    configureTexture(normalTexture);
  }

  // Function to check if a mesh belongs to target groups
  function isTargetGroup(mesh) {
    if (!mesh.name) return false;

    // Check if mesh is in exclude groups
    if (excludeGroups.some(exclude => mesh.name.toLowerCase().includes(exclude.toLowerCase()))) {
      return false;
    }

    // Check if mesh is in target groups
    return targetGroups.some(target => mesh.name.toLowerCase().includes(target.toLowerCase()));
  }

  // Function to check if a mesh belongs to target groups (including parent hierarchy)
  function isInTargetGroup(mesh) {
    if (isTargetGroup(mesh)) return true;

    let parent = mesh.parent;
    while (parent) {
      if (isTargetGroup(parent)) return true;
      parent = parent.parent;
    }
    return false;
  }

  // Function to check if material name should be excluded
  function shouldExcludeMaterial(mesh) {
    if (!excludeMaterialName || !mesh.material) return false;

    // Check if material name matches the exclude pattern
    return mesh.material.name === excludeMaterialName;
  }

    // Function to apply textures to a mesh
    function applyTexturesToMesh(mesh) {
    if (!mesh.isMesh || !mesh.material) return;
    if (!isInTargetGroup(mesh) || shouldExcludeMaterial(mesh)) return;
    
    const m = mesh.material;
    
    // Don't replace the material — just patch maps
    if (colorTexture) {
      m.map = colorTexture;
      m.map.needsUpdate = true;
    }
  
    if (normalTexture) {
      m.normalMap = normalTexture;
      m.normalMap.needsUpdate = true;
    }

//     colorTexture.encoding = THREE.sRGBEncoding;
// colorTexture.colorSpace = THREE.SRGBColorSpace; // r155+
// colorTexture.needsUpdate = true;
    if(type === 'buttonFab'){
      m.color.setScalar(0.20); // 45% darker

      m.metalness = 0.5
      m.roughness = 0.5
    }
    m.needsUpdate = true;
  }

  // Traverse and apply textures
  suitGroup.traverse((child) => {
    applyTexturesToMesh(child);
  });
}

/**
 * Load and apply fabric textures to the model
 * @param {string} colorTextureUrl - URL or path to the fabric color texture
 * @param {string} normalTextureUrl - URL or path to the fabric normal texture
 * @param {Object} materialOptions - Additional material properties
 */
function loadAndApplyFabric(colorTextureUrl, normalTextureUrl, materialOptions = {}, targetGroups = ['Front', 'shoulders', 'vent', 'ChestPocket', 'lapel', 'Sidepocket', 'Sleeve_design', 'Inverted_Box_Pleat', 'Martingale_Belt'], excludeGroups = ['Buttons', 'lining', 'full']) {
    const textureLoader = new THREE.TextureLoader();
    let colorTextureLoaded = false;
    let normalTextureLoaded = false;
    let colorTexture, normalTexture;

    // If no normal texture, treat it as "loaded" so color alone can apply.
    if (!normalTextureUrl) {
        normalTextureLoaded = true;
        normalTexture = null;
    }

    // Load color texture
    textureLoader.load(
        colorTextureUrl,
        (texture) => {
            colorTexture = texture;
            colorTextureLoaded = true;

            if (colorTextureLoaded && normalTextureLoaded) {
                applyTexturesToGroups(colorTexture, normalTexture, targetGroups, materialOptions, excludeGroups);
                // Also apply the same fabric texture to buttonhole lapel elements

                // Force a second application after a short delay to ensure consistency
                setTimeout(() => {
                    applyTexturesToButtonholeLapel(colorTexture, normalTexture, materialOptions);
                }, 100);
            }
        },
        undefined,
        (error) => {
            console.error('❌ Error loading color texture:', error);
            // Fallback to default fabric texture (if provided and not already used)
            if (DEFAULT_FABRIC_TEXTURE_URL && colorTextureUrl !== DEFAULT_FABRIC_TEXTURE_URL) {
                textureLoader.load(
                    DEFAULT_FABRIC_TEXTURE_URL,
                    (texture) => {
                        colorTexture = texture;
                        colorTextureLoaded = true;
                        if (colorTextureLoaded && normalTextureLoaded) {
                            applyTexturesToGroups(colorTexture, normalTexture, targetGroups, materialOptions, excludeGroups);
                            setTimeout(() => {
                                applyTexturesToButtonholeLapel(colorTexture, normalTexture, materialOptions);
                            }, 100);
                        }
                    },
                    undefined,
                    (fallbackError) => {
                        console.error('❌ Error loading DEFAULT fabric texture:', fallbackError);
                    }
                );
            }
        }
    );

    // Load normal texture
    if (normalTextureUrl) {
        textureLoader.load(
            normalTextureUrl,
            (texture) => {
                normalTexture = texture;
                normalTextureLoaded = true;

                if (colorTextureLoaded && normalTextureLoaded) {
                    applyTexturesToGroups(colorTexture, normalTexture, targetGroups, materialOptions, excludeGroups);
                    // Force a second application after a short delay to ensure consistency
                    setTimeout(() => {
                        applyTexturesToButtonholeLapel(colorTexture, normalTexture, materialOptions);
                    }, 100);
                }
            },
            undefined,
            (error) => {
                console.error('❌ Error loading normal texture:', error);
                // Still allow color-only application
                normalTextureLoaded = true;
                normalTexture = null;
                if (colorTextureLoaded && normalTextureLoaded) {
                    applyTexturesToGroups(colorTexture, null, targetGroups, materialOptions, excludeGroups);
                    setTimeout(() => {
                        applyTexturesToButtonholeLapel(colorTexture, null, materialOptions);
                    }, 100);
                }
            }
        );
    }
}

// Add fabric update function
let updateFabric = (fabric) => {
    // Support either a fabric object or a fabric id.
    const resolvedFabric =
        typeof fabric === "string"
            ? (allfabrics?.find((f) => f.id === fabric) ?? DEFAULT_FABRIC_FALLBACK)
            : (fabric ?? DEFAULT_FABRIC_FALLBACK);

    const colorUrl =
        resolvedFabric?.repeatable_color_image_url || DEFAULT_FABRIC_TEXTURE_URL;
    const normalUrl = resolvedFabric?.repeatable_normal_image_url || null;

    if (!colorUrl) {
        console.warn("No fabric color texture URL found (and no default provided).");
        return;
    }

    loadAndApplyFabric(colorUrl, normalUrl, { repeat: [30, 30] });
}

// Add button fabric update function
function updateButtonFabric(fabricKey) {
  // Load and apply the new button fabric
  loadAndApplyButtonFabric(fabricKey, null, {
    repeat: [1, 1],
  });

  // Update UI to show selected button fabric
  // updateButtonFabricSelectionUI(fabricKey);
}

// Add lining fabric update function
function updateLiningFabric(fabricKey) {
  loadAndApplyLiningFabric(fabricKey);
}

// Add function to update button fabric selection UI
function updateButtonFabricSelectionUI(selectedFabric) {
  const fabricOptions = document.querySelectorAll('[data-fabric^="button-fabric"]');
  fabricOptions.forEach(option => {
    option.classList.remove('selected');
    if (option.dataset.fabric === selectedFabric) {
      option.classList.add('selected');
    }
  });
}

// Add function to update lining fabric selection UI
function updateLiningFabricSelectionUI(selectedFabric) {
  const fabricOptions = document.querySelectorAll('[data-fabric^="lining-fabric"]');
  fabricOptions.forEach(option => {
    option.classList.remove('selected');
    if (option.dataset.fabric === selectedFabric) {
      option.classList.add('selected');
    }
  });
}

// ----- Update Vent Options Based on Martingale Belt and Inverted Box Pleat -----
function updateVentOptions() {
  const ventSelect = currentVent
  updateVent(ventSelect);
}

function updateMartingaleBeltOptions() {
  martingaleBelt(currentMartingaleBelt);
  updateVent();
  updateVentOptions();
}

function updateInvertedBoxPleatOptions() {
  invertedBoxPleat(currentInvertedBoxPleat);
  updateVent();
  updateVentOptions();
}

// Add this function after the updateInvertedBoxPleatOptions function (around line 1430)
function updateChestPocketOptions() {
  updateChestPocket(currentChestPocket);
}

// Add this function after the updateChestPocketOptions function
function updateSidePocketOptions() {
  updateSidePocket(currentSidePocket);
}

// Add this function after updateSidePocketOptions
function updateButtonholeLapelPositionOptions() {
  updateButtonholeLapelPosition(currentButtonholeLapelPosition);
}

// Add this function after updateButtonholeLapelPositionOptions
function updateSleeveDesignOptions() {
  updateSleeveDesign(currentSleeveDesign);
}

// ----- Update On Config Change -----
function handleConfigChange(configType, value) {
  // const configType = event.target.id.replace('-select', '');
  // const value = event.target.value;
  // CONFIG.defaults[configType] = value;

  if (configType === 'buttoning') {
    updateButtoning(value);

    updateLapelOptions(value);
    updateFront();
    updateVent();
    invertedBoxPleat();
    updateLinings();
    martingaleBelt(currentMartingaleBelt, currentMartingaleBelt );
    updateVentOptions();
    updateMartingaleBeltOptions();
    updateInvertedBoxPleatOptions(); // Add this line
  }

  if (configType === 'lapel-style') {
    updateLapelStyle(value);
    updateFront();
    // Update buttonhole position when lapel style changes
    const currentButtonholePosition = getConfigValue('buttonholeLapelPosition');
    updateButtonholeLapelPosition(currentButtonholePosition);
    updateMartingaleBeltOptions();
    updateInvertedBoxPleatOptions();
    updateChestPocketOptions();
    updateSidePocketOptions();
    updateButtonholeLapelPositionOptions(); // Add this line
    updateSleeveDesignOptions(); // Add this line
  }

  if (configType === 'shoulder') {
    updateShoulders(value);
    updateFront();
    updateVent();
    invertedBoxPleat(true);
    updateMartingaleBeltOptions();
    updateInvertedBoxPleatOptions(); // Add this line
  }

  if (configType === 'inverted-box-pleat') {
    currentInvertedBoxPleat = value;
    invertedBoxPleat(value);
    updateVent();
    updateVentOptions();
    updateMartingaleBeltOptions();
    updateInvertedBoxPleatOptions(); // Add this line
  }

  if (configType === 'vent') {
    currentVent = value;
    if (value === 'single') {
      updateVent('single');
    } else if (value === 'vent_Single_with_Button') {
      updateVent('vent_Single_with_Button');
    }
  }

  if (configType === 'martingale-belt') {
    const isVisible = value === 'true';
    currentMartingaleBelt = value;
    martingaleBelt(value, value);
    updateVent();
    updateVentOptions();
    updateInvertedBoxPleatOptions(); // Add this line
  }

  if (configType === 'chest-pocket') {
    updateChestPocket(value);
  }

  if (configType === 'side-pocket') {
    updateSidePocket(value);
  }

  if (configType === 'sleeve-design') {
    updateSleeveDesign(value);
  }

  if (configType === 'lining') {
    if (value === 'full') {
      updateLinings(true);
    } else {
      updateLinings(false);
    }
  }

  if (configType === 'buttonhole-lapel') {
    currentButtonholeLapel = value;
    updateButtonholeLapel(value);

  }

  if (configType === 'buttonhole-lapel-position') {
    currentButtonholeLapelPosition = value;
    updateButtonholeLapelPosition(value);

  }
}

// Add fabric change handler
function handleFabricChange(fabricKey) {
  CONFIG.defaults.fabric = fabricKey;
  updateFabric(fabricKey);
}

// Add button fabric change handler
function handleButtonFabricChange(fabricKey) {
  CONFIG.defaults.buttonFabric = fabricKey;
  updateButtonFabric(fabricKey);
}

// Add lining fabric change handler
function handleLiningFabricChange(fabricKey) {
  CONFIG.defaults.liningFabric = fabricKey;
  updateLiningFabric(fabricKey);
}

// ----- Update Lapel Options Based on Buttoning -----
function updateLapelOptions(buttoningType) {
  const currentLapelValue = currentLapelStyle;
  const allowedLapelStyles = CONFIG.lapelConstraints[buttoningType] || ['notch', 'peak', 'notchpeak'];

  const lapelOptions = {
    notch: 'NOTCH',
    peak: 'PEAK',
    notchpeak: 'NOTCHPEAK'
  };

  allowedLapelStyles.forEach(style => {
    const option = document.createElement('option');
    option.value = style;
    option.textContent = lapelOptions[style];
  });

  // Set a valid default if current selection is not allowed
  if (!allowedLapelStyles.includes(currentLapelValue)) {
    const newDefault = allowedLapelStyles[0];
    CONFIG.defaults.lapelStyle = newDefault;
    currentLapelStyle = newDefault;
  } else {
    // Keep the current selection if it's valid
    currentLapelStyle = currentLapelValue;
  }
  updateLapelStyle(currentLapelStyle);
}

/**
 * Load and apply button fabric textures with special handling for notch_lapel_left_button
 * @param {string} colorTextureUrl - URL or path to the button fabric color texture
 * @param {string} normalTextureUrl - URL or path to the button fabric normal texture
 * @param {Object} materialOptions - Additional material properties
 */
function loadAndApplyButtonFabric(colorTextureUrl, normalTextureUrl, materialOptions = {}) {
  const textureLoader = new THREE.TextureLoader();
  let colorTextureLoaded = false;
  let normalTextureLoaded = false;
  let colorTexture, normalTexture;

  // Load color texture
  textureLoader.load(
    `https://grand-le-mar-uploads-2.s3.ap-south-1.amazonaws.com/buttons/overcoat/${colorTextureUrl}.png`,
    (texture) => {
      colorTexture = texture;
      colorTextureLoaded = true;

      if (colorTextureLoaded) {
        applyTexturesToGroupsWithMaterialConstraint(colorTexture, null, [
          'Buttons', '2_Buttons', '6_buttons', 'belt_button', 'belt_buttons',
          'pleat_buttons', 'sleave_buttons', 'sec_strap', 'one_strap_button'
        ], materialOptions, [
          'Full_Sleeve_Strap_with_buttons', 'Sleeve_Eqaulettes003',
          'one_strap002', 'lapel', 'buttonhole_lapel'
        ], 'Thread_Mat', "buttonFab");
      }
    },
    undefined,
    (error) => {
      console.error('❌ Error loading button color texture:', error, colorTextureUrl);
    }
  );

  // if (normalTextureUrl !== null) {
  //   // Load normal texture
  //   textureLoader.load(
  //     normalTextureUrl,
  //     (texture) => {
  //       normalTexture = texture;
  //       normalTextureLoaded = true;

  //       if (colorTextureLoaded && normalTextureLoaded) {
  //         // Apply button fabric texture to all button elements except buttonhole lapel elements
  //         // Exclude meshes with material name "Thread_Mat"
  //         applyTexturesToGroupsWithMaterialConstraint(colorTexture, normalTexture, [
  //           'Buttons', '2_Buttons', '6_buttons', 'belt_button', 'belt_buttons',
  //           'pleat_buttons', 'sleave_buttons', 'sec_strap', 'one_strap_button'
  //         ], materialOptions, [
  //           'Full_Sleeve_Strap_with_buttons', 'Sleeve_Eqaulettes003',
  //           'one_strap002', 'lapel'
  //         ], 'Thread_Mat', "buttonFab");
  //       }
  //     },
  //     undefined,
  //     (error) => {
  //       console.error('❌ Error loading button normal texture:', error,normalTextureUrl );
  //     }
  //   );
  // }
}

/**
 * Apply the same fabric texture to buttonhole lapel elements
 * @param {THREE.Texture} colorTexture - The fabric color texture to apply
 * @param {THREE.Texture} normalTexture - The fabric normal texture to apply
 * @param {Object} materialOptions - Additional material properties
 */
function applyTexturesToButtonholeLapel(colorTexture, normalTexture, materialOptions = {}) {
  if (!suitGroup) return;

  // Configure texture settings
  const configureTexture = (texture) => {
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;
    texture.encoding = THREE.sRGBEncoding;

    const maxAnisotropy = renderer.capabilities.getMaxAnisotropy();
    texture.anisotropy = Math.min(maxAnisotropy, 16); // Cap at 16 for performance

    texture.generateMipmaps = true;
    texture.minFilter = THREE.LinearMipmapLinearFilter;
    texture.magFilter = THREE.LinearFilter;

    const repeatX = materialOptions.repeat?.[0] || 10;
    const repeatY = materialOptions.repeat?.[1] || 10;
    texture.repeat.set(repeatX, repeatY);
  };

  // Configure both textures
  configureTexture(colorTexture);
  if (normalTexture) {
    configureTexture(normalTexture);
  }

  // Define all buttonhole lapel mesh names that should get the same fabric texture
  const buttonholeLapelMeshes = [
    'notch_lapel_left_traditional',
    'notch_lapel_right_traditional',
    'notch_left_Handmade_milanese',
    'notch_right_Handmade_milanese',
    'peak_left_traditional_button',
    'peak_right_traditional_button',
    'peak_left_Handmade_milanese',
    'peak_right_Handmade_milanese',
    'notchpeak_lapel_left_traditional',
    'notchpeak_lapel_right_traditional',
    'notchpeak_left_Handmade_milanese',
    'notchpeak_right_Handmade_milanese'
  ];

  let appliedCount = 0;

  // Function to apply textures to buttonhole lapel meshes
  function applyTexturesToButtonholeMesh(mesh) {
    if (mesh.isMesh && buttonholeLapelMeshes.includes(mesh.name)) {

      // Force material update and ensure proper material properties
      if (!mesh.material) {
        mesh.material = new THREE.MeshStandardMaterial();
      }

      // Apply the fabric texture
      mesh.material.map = colorTexture;
      if (normalTexture) {
        mesh.material.normalMap = normalTexture;
        mesh.material.normalMap.needsUpdate = true;
      }

      // Set material properties
      mesh.material.polygonOffset = true;
      mesh.material.polygonOffsetFactor = 1;
      mesh.material.polygonOffsetUnits = 1;
      mesh.material.depthWrite = true;
      mesh.material.depthTest = true;
      mesh.material.roughness = 1;
      mesh.material.metalness = 0.5;
      mesh.material.needsUpdate = true;

      appliedCount++;
    }
  }

  // Traverse and apply textures to buttonhole lapel elements
  suitGroup.traverse((child) => {
    applyTexturesToButtonholeMesh(child);
  });
}

/**
 * Load and apply lining fabric textures
 * @param {string} colorTextureUrl - URL or path to the lining fabric color texture
 * @param {string} normalTextureUrl - URL or path to the lining fabric normal texture
 * @param {Object} materialOptions - Additional material properties
 */
function loadAndApplyLiningFabric(liningColor) {
    if (!suitGroup) return;

    const targetGroups = ['LiningSleeve', 'full'];
    const excludeGroups = ['Front', 'shoulders', 'vent', 'ChestPocket', 'Sidepocket', 'Sleeve_design', 'Inverted_Box_Pleat', 'Martingale_Belt', 'Buttons', 'lapel'];

    // Get color from materialOptions (can be hex string, hex number, or THREE.Color)
    const color = liningColor

    // Function to check if a mesh belongs to target groups
    function isTargetGroup(mesh) {
        if (!mesh.name) return false;

        // Check if mesh is in exclude groups
        if (excludeGroups.some(exclude => mesh.name.toLowerCase().includes(exclude.toLowerCase()))) {
            return false;
        }

        // Check if mesh is in target groups
        return targetGroups.some(target => mesh.name.toLowerCase().includes(target.toLowerCase()));
    }

    // Function to check if a mesh belongs to target groups (including parent hierarchy)
    function isInTargetGroup(mesh) {
        if (isTargetGroup(mesh)) return true;

        let parent = mesh.parent;
        while (parent) {
            if (isTargetGroup(parent)) return true;
            parent = parent.parent;
        }
        return false;
    }

    // Function to apply color to a mesh
    function applyColorToMesh(mesh) {
        if (mesh.isMesh && mesh.material && isInTargetGroup(mesh)) {
          mesh.material.color.set(color);
          mesh.material.map = null;
          mesh.material.metalnessMap = null;
          mesh.material.roughnessMap = null;
          mesh.material.normal = null;
          mesh.material.needsUpdate = true;
          mesh.material.metalness = 0.5;
          mesh.material.roughness = 1;
        }
    }

    // Traverse and apply color
    suitGroup.traverse((child) => {
        applyColorToMesh(child);
    });
}

// ----- Initialize Fabric Selection UI -----
function initFabricSelectionUI() {
  // Add fabric card selection event listeners
  const fabricCards = document.querySelectorAll('.fabric-card');
  fabricCards.forEach(card => {
    card.addEventListener('click', () => {
      // Remove selection from all cards
      fabricCards.forEach(c => c.classList.remove('selected'));
      // Add selection to clicked card
      card.classList.add('selected');
      selectedMainFabric = card.dataset.fabric;

      // Update the 3D model with selected fabric
      updateFabric(selectedMainFabric);
    });
  });

  // Add next button event listener
  const fabricNextBtn = document.getElementById('fabric-next-btn');
  if (fabricNextBtn) {
    fabricNextBtn.addEventListener('click', () => {
      if (selectedMainFabric) {
        showConfigurationUI();
      } else {
        alert('Please select a fabric first');
      }
    });
  }

  // Add back button event listener in config UI
  const backToFabricBtn = document.getElementById('back-to-fabric-btn');
  if (backToFabricBtn) {
    backToFabricBtn.addEventListener('click', () => {
      showFabricSelectionUI();
    });
  }
}

// ----- Show/Hide UI Functions -----
function showConfigurationUI() {
  currentScreen = 'config';
  document.getElementById('fabric-selection-screen').style.display = 'none';
  document.getElementById('config-sidebar').style.display = 'flex';

  // Initialize the configuration UI if not already done
  if (!window.configUIInitialized) {
    initConfigUI();
    window.configUIInitialized = true;
  }
}

function showFabricSelectionUI() {
  currentScreen = 'fabric-selection';
  document.getElementById('config-sidebar').style.display = 'none';
  document.getElementById('fabric-selection-screen').style.display = 'flex';
}

// ----- Update Fabric Selection UI -----
function updateFabricSelectionUI(selectedFabric) {
  // Update fabric cards in the fabric selection screen
  const fabricCards = document.querySelectorAll('.fabric-card');
  fabricCards.forEach(card => {
    card.classList.remove('selected');
    if (card.dataset.fabric === selectedFabric) {
      card.classList.add('selected');
    }
  });

  // Also update fabric options in the config UI if they exist
  const fabricOptions = document.querySelectorAll('.fabric-option');
  fabricOptions.forEach(option => {
    option.classList.remove('selected');
    if (option.dataset.fabric === selectedFabric) {
      option.classList.add('selected');
    }
  });
}

// ----- Initialize DOM Selectors & Events -----
function initConfigUI() {
  setTimeout(() => {
  let parentDivs = document.querySelectorAll(".cm-modifier-card-container");
  let resultTitleText, resultTitleTextWithoutSpaces, childDiv, resultTitleDiv, filter_label, filter_label_value;

  if(dataPageValue === "custom-made-overcoat"){
            for (let i = 0; i < parentDivs.length; i++) {
                childDiv = parentDivs[i].querySelector(".cm-modifier-card-wrapper");

                if (childDiv) {
                    // Access data or perform actions on the child div
                    filter_label = childDiv.querySelector(".cm-modifier-col-title");
                    // Find the children div with class "cm-modifier-result-title" within childDiv
                    resultTitleDiv = childDiv.querySelector(".cm-modifier-result-title");

                    if (resultTitleDiv) {
                        resultTitleText = resultTitleDiv.textContent.trim(); // Remove leading and trailing spaces
                        filter_label_value = filter_label.textContent.trim();
                        resultTitleTextWithoutSpaces = resultTitleText.replace(
                            /[.\s:]+/g,
                            "_"
                        ); // Replace spaces and dots with underscores
                        filter_label_value = filter_label_value.replace(
                            /[.\s:]+/g,
                            "_"
                        );

                        if(filter_label_value === 'Buttoning'){
                          if(resultTitleTextWithoutSpaces === "Single_Breasted_2_5_button"){
                            currentButtoning = 'single_breasted_2'
                          }
                          if(resultTitleTextWithoutSpaces === "Double_Breasted_6_button"){
                            currentButtoning = 'double_breasted_6'
                          }
                          handleConfigChange('buttoning',currentButtoning)
                        }
                        
                        if(filter_label_value === 'Lapel_style'){
                          if(resultTitleTextWithoutSpaces === "Peak"){
                            currentLapelStyle = 'peak'
                          }
                          if(resultTitleTextWithoutSpaces === "Notch"){
                            currentLapelStyle = 'notch'
                          }
                          if(resultTitleTextWithoutSpaces === "Notch_Peak"){
                            currentLapelStyle = 'notchpeak'
                          }
                          handleConfigChange('lapel-style',currentLapelStyle)
                        }

                        if(filter_label_value === 'Shoulder'){
                          if(resultTitleTextWithoutSpaces === "Natural_Shoulder_-_Unconstructed_(0_mm)"){
                            currentLapelStyle = 'Unconstructed'
                          }
                          if(resultTitleTextWithoutSpaces === "Natural_Shoulder_-_Lightly_Padded_(2_mm)"){
                            currentLapelStyle = 'Lightly_Padded'
                          }
                          if(resultTitleTextWithoutSpaces === "Natural_Shoulder_-_Structured_(5_mm)"){
                            currentLapelStyle = 'Structured'
                          }

                          handleConfigChange('shoulder',currentLapelStyle)
                        }

                        if(filter_label_value === 'Inverted_box_pleat'){
                          if(resultTitleTextWithoutSpaces === 'Yes'){
                            currentInvertedBoxPleat = true
                          }
                          if(resultTitleTextWithoutSpaces === 'No'){
                            currentInvertedBoxPleat = false
                          }
                          handleConfigChange('inverted-box-pleat',currentInvertedBoxPleat)
                        }

                        if(filter_label_value === 'Martingale_belt'){
                          if(resultTitleTextWithoutSpaces === 'Yes'){
                            currentMartingaleBelt = true
                          }
                          if(resultTitleTextWithoutSpaces === 'No'){
                            currentMartingaleBelt = false
                          }

                          handleConfigChange('martingale-belt',currentMartingaleBelt)
                        }

                        if(filter_label_value === 'Vent'){
                          
                          if(resultTitleTextWithoutSpaces === 'Single'){
                            currentVent = 'single'
                          }
                          if(resultTitleTextWithoutSpaces === 'Single_with_buttons'){
                            currentVent = 'vent_Single_with_Button'
                          }
                          handleConfigChange('vent',currentVent)
                        }

                        if(filter_label_value === 'Chest_pocket'){
                          if(resultTitleTextWithoutSpaces === 'Boat'){
                            currentChestPocket = 'boat'
                          }
                          if(resultTitleTextWithoutSpaces === 'None'){
                            currentChestPocket = 'none'
                          }
                          handleConfigChange('chest-pocket',currentChestPocket)
                        }

                        if(filter_label_value === 'Side_pockets'){
                          if(resultTitleTextWithoutSpaces === 'Postbox'){
                            currentSidePocket = 'postbox'
                          }

                          if(resultTitleTextWithoutSpaces === 'Jetted'){
                            currentSidePocket = 'jetted'
                          }

                          if(resultTitleTextWithoutSpaces === 'Flaps'){
                            currentSidePocket = 'flaps'
                          }

                          if(resultTitleTextWithoutSpaces === 'Slanted_Welt'){
                            currentSidePocket = 'slanted-welt'
                          }
                          handleConfigChange('side-pocket',currentSidePocket)
                        }
                        
                        if(filter_label_value === 'Buttons'){
                         currentButtonfab = resultTitleTextWithoutSpaces
                          loadAndApplyButtonFabric(currentButtonfab, null, {repeat: [1, 1]})
                        }
                        
                        if(filter_label_value === 'Sleeve_design'){
                          if(resultTitleTextWithoutSpaces === 'Cuffed'){
                            currentSleeveDesign = 'cuffed'
                          }
                          if(resultTitleTextWithoutSpaces === 'Uncuffed'){
                            currentSleeveDesign = 'un-cuffed'
                          }
                          if(resultTitleTextWithoutSpaces === 'Sleeve-strap'){
                            currentSleeveDesign = 'sleeve-strap'
                          }
                          if(resultTitleTextWithoutSpaces === 'Sleeve-strap-with-buttons'){
                            currentSleeveDesign = 'sleeve-strap-with-buttons'
                          }
                          handleConfigChange('sleeve-design',currentSleeveDesign)
                        }

                        if(filter_label_value === 'Lining'){
                          console.log("Lining value", resultTitleTextWithoutSpaces)
                        }

                        if(filter_label_value === 'Lining_colour'){
                          currentLiningsColor = getLiningColor(resultTitleTextWithoutSpaces)
                          handleLiningFabricChange(currentLiningsColor)

                        }

                        // if(filter_label_value === 'Monogram'){

                        // }

                        // if(filter_label_value === 'Construction'){

                        // }

                        // if(filter_label_value === 'AMF'){

                        // }

                        if(filter_label_value === 'Buttonhole_lapel_position'){
                          if(resultTitleTextWithoutSpaces === 'Left_(Standard)'){
                            currentButtonholeLapelPosition = 'left'
                          }
                          if(resultTitleTextWithoutSpaces === 'Right'){
                            currentButtonholeLapelPosition = 'right'
                          }
                          if(resultTitleTextWithoutSpaces === 'Both'){
                            currentButtonholeLapelPosition = 'both'
                          }

                          if(resultTitleTextWithoutSpaces === 'None'){
                            currentButtonholeLapelPosition = 'none'
                          }
                          handleConfigChange('buttonhole-lapel-position',currentButtonholeLapelPosition)
                        }

                        if(filter_label_value === 'Buttonhole_lapel'){
                          let selectedButtonholeLapel = currentButtonholeLapel;
                            if (resultTitleTextWithoutSpaces === 'Handmade_milanese') {
                                selectedButtonholeLapel = 'handmade-milanese';
                            }
                            if (resultTitleTextWithoutSpaces === 'Traditional') {
                                selectedButtonholeLapel = 'traditional';
                            }

                            currentButtonholeLapel = selectedButtonholeLapel;
                            handleConfigChange('buttonhole-lapel', selectedButtonholeLapel);
                        }

                        // if(filter_label_value === 'Overcoat'){

                        // }


                        // handleConfigChange(filter_label_value, resultTitleTextWithoutSpaces)
                    }
                  }
              }
  }

  // const selects = [
  //   'buttoning', 'lapel-style', 'shoulder', 'martingale-belt',
  //   'inverted-box-pleat', 'vent', 'side-pocket', 'chest-pocket', 'sleeve-design', 'lining', 'buttonhole-lapel-position', 'buttonhole-lapel'
  // ];

  // selects.forEach(id => {
  //   const domId = `${id}-select`;
  //   const element = document.getElementById(domId);
  //   if (element) {
  //     element.addEventListener('change', handleConfigChange);
  //   }
  // });

  // // Add button fabric selection event listeners
  // const buttonFabricOptions = document.querySelectorAll('[data-fabric^="button-fabric"]');
  // buttonFabricOptions.forEach(option => {
  //   option.addEventListener('click', () => {
  //     const fabricKey = option.dataset.fabric;
  //     handleButtonFabricChange(fabricKey);
  //   });
  // });

  // // Add lining fabric selection event listeners
  // const liningFabricOptions = document.querySelectorAll('[data-fabric^="lining-fabric"]');
  // liningFabricOptions.forEach(option => {
  //   option.addEventListener('click', () => {
  //     const fabricKey = option.dataset.fabric;
  //     handleLiningFabricChange(fabricKey);
  //   });
  // });

  // // Initialize lapel options based on default buttoning
  // updateLapelOptions(CONFIG.defaults.buttoning);

  // // Initialize vent options based on current martingale belt and inverted box pleat settings
  // updateVentOptions();

  // // Initialize martingale belt options based on inverted box pleat and lapel style
  // updateMartingaleBeltOptions();

  // // Initialize inverted box pleat options based on lapel style
  // updateInvertedBoxPleatOptions();

  // // Initialize chest pocket options based on lapel style
  // updateChestPocketOptions(); // Add this line

  // // Initialize side pocket options based on lapel style
  // updateSidePocketOptions(); // Add this line

  // // Initialize button and lining fabric selection UIs
  // updateButtonFabricSelectionUI(CONFIG.defaults.buttonFabric);
  // updateLiningFabricSelectionUI(CONFIG.defaults.liningFabric);

  // // Initialize side pocket options based on lapel style
  // updateSidePocketOptions();

  // // Initialize buttonhole lapel position options based on lapel style
  // updateButtonholeLapelPositionOptions(); // Add this line

  // // Initialize sleeve design options based on lapel style
  // updateSleeveDesignOptions(); // Add this line

},450)
}

// ----- Init Everything on Load -----
// document.addEventListener('DOMContentLoaded', () => {
//   // initFabricSelectionUI(); // Initialize fabric selection UI first


//   // Set default fabric selection
//   // selectedMainFabric = CONFIG.defaults.fabric;
//   // updateFabricSelectionUI(selectedMainFabric);
//   // updateFabric(selectedMainFabric);
// });

// ----- Handle Resize -----
window.addEventListener('resize', () => {
  const viewerDiv = document.getElementById("CanvasFrame");
  const viewerWidth = viewerDiv.clientWidth;
  const viewerHeight = viewerDiv.clientHeight;

  camera.left = viewerWidth / -650;
  camera.right = viewerWidth / 650;
  camera.top = viewerHeight / 650;
  camera.bottom = viewerHeight / -650;
  camera.updateProjectionMatrix();

  renderer.setSize(viewerWidth, viewerHeight);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2)); // Add this line

  // Update FXAA resolution if you added it
  if (composer.passes.length > 1) {
    const fxaaPass = composer.passes[1];
    const pixelRatio = renderer.getPixelRatio();
    fxaaPass.material.uniforms['resolution'].value.x = 1 / (viewerWidth * pixelRatio);
    fxaaPass.material.uniforms['resolution'].value.y = 1 / (viewerHeight * pixelRatio);
  }
});

// Fix the button scaling function to use correct mesh names
function scaleButtonsOnXAxis(scaleFactor = 1.2) {
  if (!suitGroup) {
    console.warn('Suit group not found');
    return;
  }

  // Define all button group names that should be scaled
  const buttonGroups = [
    'Buttons', '2_Buttons', '6_buttons', 'belt_button', 'belt_buttons',
    'pleat_buttons', 'sleave_buttons', 'sec_strap', 'one_strap_button'
  ];

  // Function to scale a mesh or group on X axis
  function scaleMeshOnX(mesh, scaleX) {
    if (mesh.isMesh) {
      // Store original scale if not already stored
      if (!mesh.userData.originalScale) {
        mesh.userData.originalScale = {
          x: mesh.scale.x,
          y: mesh.scale.y,
          z: mesh.scale.z
        };
      }

      // Apply scaling only on X axis
      mesh.scale.x = mesh.userData.originalScale.x * scaleX;
      mesh.scale.needsUpdate = true;
    }
  }

  // Traverse through the suit group to find and scale buttons
  suitGroup.traverse((child) => {
    // Check if the current child is a button group
    if (buttonGroups.includes(child.name)) {
      // Scale the button group itself
      scaleMeshOnX(child, scaleFactor);

      // Also scale all children within the button group
      child.traverse((subChild) => {
        scaleMeshOnX(subChild, scaleFactor);
      });
    }
  });
}

// Function to reset button scaling to original size
function resetButtonScaling() {
  if (!suitGroup) {
    console.warn('Suit group not found');
    return;
  }

  suitGroup.traverse((child) => {
    if (child.userData.originalScale) {
      child.scale.x = child.userData.originalScale.x;
      child.scale.y = child.userData.originalScale.y;
      child.scale.z = child.userData.originalScale.z;
      child.scale.needsUpdate = true;
    }
  });
}

/**
 * Retrieves the selected value for a customization property from the Shopify UI DOM.
 * @param {string} filterLabelText - The exact text of the property label (e.g., "Shoulders").
 * @returns {string|null} The cleaned value string for the 3D model, or null if not found.
 */
function getCustomizationValue(filterLabelText) {
    // Select all the parent card containers for customization options
    const parentDivs = document.querySelectorAll(".cm-modifier-card-container");
    let resultValue = null;

    for (const parentDiv of parentDivs) {
        // Find the title/label element
        const filterLabel = parentDiv.querySelector(".cm-modifier-col-title");
        // Find the result/selected value element
        const resultTitleDiv = parentDiv.querySelector(".cm-modifier-result-title");

        if (filterLabel && resultTitleDiv) {
            const filter_label_value = filterLabel.textContent.trim();

            // 1. Check if the current card is the one we are looking for
            if (filter_label_value === filterLabelText) {
                const rawText = resultTitleDiv.textContent.trim();
                
                // 2. Map/Clean the value string for use in 3D model functions.
                // This step replicates the cleaning/mapping logic from your existing modelvales.
                // Example: "Natural Shoulder 0mm" -> "Natural_Shoulder_0mm"
                resultValue = rawText.replace(/\s+/g, "_").replace(/[^a-zA-Z0-9_]/g, '');
                
                // **IMPORTANT: Add property-specific mapping here if needed.**
                // For example, your current modelvales converts "No_pleats" to "Normal_straight_pant".
                if (filterLabelText === 'Pleats' && resultValue === "No_pleats") {
                    resultValue = "Normal_straight_pant";
                }
                
                return resultValue;
            }
        }
    }
    return resultValue;
}

function getLiningColor(color_code) {
    switch (color_code) {
        case "White":
            return "#FFFFFF";
            break;
        case "Black":
            return "#111111";
            break;
        case "Dark_Navy":
            return "#112139";
            break;
        case "Navy":
            return "#1D1F34";
            break;
        case "Mid_Navy":
            return "#1A2F4C";
            break;
        case "Dark_Grey":
            return "#4D4D4D";
            break;
        case "Light_Grey":
            return "#898989";
            break;
        case "Brown":
            return "#2e241e";
            break;
        case "Light_Blue":
            return "#9AB5C0";
            break;
        case "Light_Brown":
            return "#685037";
            break;
        case "Dark_Brown":
            return "#52402E";
            break;
        case "Beige":
            return "#AB947A";
            break;
        case "Khaki_green":
            return "#453b22";
            break;
        case "Pink":
            return "#9c5a70";
            break;
        case "Burgundy":
            return "#5E1A27";
            break;
        case "Red":
            return "#5A0206";
            break;
        case "Orange":
            return "#A8513C";
            break;
        case "Purple":
            return "#7e4eb5";
            break;
        default:
            return "#FFFFFF";
            break;
    }
}

$(document).on(
    "click",
    ".cm-modifier-drawer[drawer-type='one'] .drawer1_apply, .cm-modifier-drawer .drawer2_apply, .cm-toggle-ele .cm-toggle-item,.btm_tab .cm-toggle-item,.btn-customize.next_button",
    function (event) {
        var currObj = this;

        // Added by softpulse
        if ($(currObj).parents(".isSelected").find(".is-selected").hasClass("cm-drawer-other-option-btn")) {
            $("body").removeClass("line-loading-3d-preview");
            currObj.classList.contains("inactive_button") ? currObj.classList.remove("inactive_button") : '';
            return;
        }
        if (event.isTrigger) {
            initConfigUI()
        }
    }
);

initThree();